import { node, arrayOf, string, oneOfType, object } from 'prop-types'

const Form = ({ children, cssClass = '', name = '', autoComplete = 'off', otherProps = {} }) => {
  return (
    <form className={cssClass} name={name} autoComplete={autoComplete} {...otherProps}>
      {children}
    </form>
  )
}

Form.propTypes = {
  autoComplete: string,
  children: oneOfType([arrayOf(node), node]),
  cssClass: string,
  id: string,
  name: string,
  otherProps: object
}

export default Form
